import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Link from '../../../../../01_atoms/Link';
import { PTBBCarousel, PTBBCarouseSliderSettings } from '../../prop-types.js';
import Button from '../../../../../01_atoms/Button';
import Slider from '../../../../../01_atoms/Slider';
import Spinner from '../../../../../01_atoms/Spinner';
import DefaultPicture from '../../../../../01_atoms/DefaultPicture';
import NextChevron from '../../../../../../public/static/icons/navigation-chevron-right-white.svg';
import { generateClassNameByBehaviorSettings } from '../../../../../../utils/behaviorSettings';

const BBCarouselDesktopStory = ({
  items,
  sliderSettings,
  activeSlideIndex,
  transitioning,
  bbCarouselStyles,
  behaviorSettings,
  uuid,
}) => {
  let sliderRef = useRef(null);
  const componentName = 'bb-carousel--desktop--story';

  const classes = [
    'bb',
    bbCarouselStyles['bb-carousel'],
    bbCarouselStyles['bb-carousel--desktop'],
    bbCarouselStyles['bb-carousel--desktop--story'],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid} data-component={componentName}>
      <div className="container">
        <Slider ref={sliderRef} {...sliderSettings}>
          {items.map((item, i) => (
            <div
              className={`item ${bbCarouselStyles['bb-carousel__item']} ${item.cta ? 'cta' : ''}`}
              key={`image-${item.title}-${i}`}
            >
              <DefaultPicture {...item.image} />
              <div className={bbCarouselStyles['bb-carousel__gradient']} />
            </div>
          ))}
        </Slider>

        <div
          className={`${bbCarouselStyles['bb-carousel__overlay']} ${items[activeSlideIndex].cta ? 'cta' : ''}`}
        >
          {items.map((item, i) => (
            <div
              key={`text-${item.title}-${i}`}
              className={`${bbCarouselStyles['bb-carousel__text']} ${
                i === activeSlideIndex ? '' : bbCarouselStyles['bb-carousel__text--hidden']
              } ${transitioning ? 'faded' : ''}`}
            >
              {item.cta && item.cta.label && item.cta.nextLink ? (
                <div>
                  {item.title && <h2 className="rockitt">{item.title}</h2>}
                  <p>
                    <Link {...item.cta.nextLink}>
                      <Button
                        href={item.cta.nextLink.url}
                        tag="a"
                        className={`${bbCarouselStyles['bb-carousel__button']}`}
                      >
                        {item.cta.label}
                      </Button>
                    </Link>
                  </p>
                </div>
              ) : (
                <>
                  {item.title && <h3>{item.title}</h3>}
                  <p>{item.description}</p>
                </>
              )}
            </div>
          ))}

          <div className={bbCarouselStyles['bb-carousel__counter']}>
            {transitioning ? (
              <Spinner />
            ) : (
              <p>
                <strong>
                  {activeSlideIndex + 1}/{items.length}
                </strong>
              </p>
            )}
          </div>

          <Button
            type="secondary"
            tag="a"
            onClick={() => {
              sliderRef.current.slickNext();
            }}
            disabled={activeSlideIndex === items.length - 1}
            className={`${bbCarouselStyles['bb-carousel__button']}`}
          >
            {items[activeSlideIndex].nextLabel
              ? items[activeSlideIndex].nextLabel
              : 'Continue the story'}
            &nbsp;
            <NextChevron />
          </Button>
        </div>
      </div>
    </div>
  );
};

BBCarouselDesktopStory.propTypes = {
  ...PTBBCarousel,
  ...PTBBCarouseSliderSettings,
  activeSlideIndex: PropTypes.number.isRequired,
  transitioning: PropTypes.bool.isRequired,
};

export default BBCarouselDesktopStory;
